<template>
    <!-- 二层弹框 无图-->
    <div v-if="is_brand" class="brand_wrap">
        <!-- 右侧字母-->
        <div class="letters">
            <ul>
                <li v-for="(item, index) in letter" :key="index" @click="to_letter(index,item)"
                    :class="activeLetter == item ? 'action' : ''">
                    {{ item }}
                </li>
            </ul>
        </div>
        <!-- letters end -->
        <!-- 左侧车型 滚动-->
        <div class="carslist" ref="carsList" @scroll="handleScroll()">
            <!-- 热门品牌-->
            <div class="dialog_hot_brand" v-if="hot.length>0">
                <div class="dialog_hot_brand_tit">
                    热门品牌 <img src="../assets/image/hot.png" alt=""
                              class="hot_img">
                </div>
                <ul class="dialog_hot_brand_ul">
                    <template v-for="(item,index) in hot">
                        <div :key="index"
                             class="hot_car_list_item"
                             @click="clk_brand(item)">
                            <div style="display: inline-block;width: 30px;height: 30px">
                                <img :src="item.logo" alt=""
                                     style="width: 30px;height: auto;margin: auto"/>
                            </div>
                            <p class="hot_brand_title">{{item.brand_name}}</p>
                        </div>
                    </template>
                </ul>
            </div>
            <!-- 车型-->
            <template v-for="(brands, letter) in brand">
                <div :key="letter">
                    <div class="character" :id="letter">
                        {{ letter }}
                    </div>
                    <ul class="car_tree">
                        <li v-for="brand in brands" :key="brand.id" @click="clk_brand(brand)">
                            <img :src="brand.logo" alt=""/>
                            <span>{{ brand.brand_name }}</span>
                        </li>
                    </ul>
                </div>
            </template>
        </div>
    </div>

    <!-- 车辆详情-->
    <div v-else class="carlist" id="dialog_view">
        <div class="carBack">
            <!-- 返回icon-->
            <i @click="is_brand = true" class="el-icon-arrow-left" style="font-size: 20px;font-weight: bold"></i>
        </div>
        <div>
            <h3>{{ brand_name }}</h3>
            <ul>
                <!--                    , automaker.name, series.name-->
                <li v-for="(series, series_id) in series_list" :key="series_id"
                    @click="clk_series(brand_id, brand_name, series.id, series.name)">
                    <img :src="series.thumb" alt="series.name" v-if="series.thumb"/>
                    <img src="../assets/image/brand_default.jpg" alt="暂无图片" v-else>
                    <div class="series-data-item-r">
                                <span class="series-data-item-model-name">{{ series.name }}
                                    <img src="../assets/image/isNew.png" alt="" v-if="series.is_new"
                                         style="width: 15px;height: 15px;position: relative;top: 3px;left: 4px">
                                </span>
                        <template>
                                    <span class="series-data-item-model-price"
                                          v-if="Number(series.msrp_min) == 0 || Number(series.msrp_max) == 0">
                                    暂无指导价
                                    </span>
                            <span class="series-data-item-model-price" v-else>指导价：{{ series.msrp_min }} - {{ series.msrp_max }}万</span>

                        </template>

                    </div>
                </li>
            </ul>
        </div>
    </div>

</template>

<script>

    import lib_car from "@/libs/lib_car";

    export default {
        props: {
            activity_id: {type: Number, default: 0}, //项目id
            custom_car: {type: Number, default: 0}, //是否自定义车型库 自定义是无图1,非自定义是有图0
        },

        data() {
            return {
                hot: [], //热门车型
                brand: [], //品牌
                letter: [], //右侧ABC
                series_list: [], //车型
                brand_id: undefined, //品牌id
                brand_name: '', //品牌name
                currIndex: 0,
                activeLetter: 'A',
                is_active: false, //获取点击字母


                is_brand: true,
                current_brand: {},
            };
        },
        created() {
            // todo 车型加载及两次请求， 无图片的(两个组件) 参数控制加载A/B
            // todo 单品，无弹框，下拉处理
            let that = this;
            lib_car.brand(this.activity_id, this.custom_car, function (data) {
                that.hot = data.hot;
                that.letter = data.letter;
                that.brand = data.brand;
                that.activeLetter = data.letter[0];
            })
            this.$nextTick(() => {
                window.addEventListener('scroll', this.handleScroll())
            })
        },
        mounted() {

        },

        methods: {
            //字母
            to_letter(index, item) {
                this.is_active = index;
                this.currIndex = index;
                this.activeLetter = item;
                document.querySelector('#' + this.activeLetter).scrollIntoView({
                    behavior: 'smooth'
                })
            },
            // 滚动
            handleScroll() {
                const leftEle = [...document.querySelectorAll('.character')];
                leftEle.forEach((item, index) => {
                    if (item.offsetTop < this.$refs.carsList.scrollTop + 5) {
                        this.activeLetter = item.innerText
                    }
                })
            },
            //选择品牌
            clk_brand(brand) {
                this.current_brand = brand;
                this.brand_id = brand.brand_id; // 品牌id
                this.brand_name = brand.brand_name;  // 品牌name
                this.is_brand = false;
                let that = this;
                lib_car.series(this.activity_id, this.custom_car, brand.brand_id, function (data) {
                    that.series_list = data
                })
            },

            //选择车型
            clk_series(brand_id, brand_name, series_id, series_name) {
                this.is_brand = true
                this.$emit("query", brand_id, brand_name, series_id, series_name);
            },
        },

        watch: {
            is_brand(v) {
                if(v==false)  {
                    this.activeLetter = this.letter[0]
                }
            }
        }
    };
</script>

<style lang="less">
    @import "../assets/style/carList/dialog_cars.less";
</style>
